module.exports = "Ext.namespace(\"SF.appt\"),SF.appt.CalendarLayoutHelper=function(a){this.config=a},Ext.extend(SF.appt.CalendarLayoutHelper,Object,{});"